var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1533.6 1055.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1512.7 477.3 1056.3 20.9c-27.8-27.8-73-27.8-100.8 0-27.8 27.9-27.8 73 0 100.8l334.6 334.6H71.3c-39.4.1-71.3 32-71.3 71.4S31.9 599 71.3 599h1218.8L955.5 933.6c-27.8 27.9-27.8 73 0 100.8 13.9 13.9 32.2 20.9 50.4 20.9s36.5-7 50.4-20.9L1512.7 578c27.9-27.7 27.9-72.9 0-100.7"
  })));
};
export default SvgArrowRight;